<template>
  <div style="margin-top: 30px">
    <p style="font-size: 16px; margin-bottom: 10px">{{$t('lang.port.addPortForwards')}}</p>
    <el-table :data="redirect" border strip>
      <el-table-column :label="`${$t('lang.ConfigSetting.Name')}`">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.options.name" required></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.Protocol')}`" min-width="100px">
        <template slot-scope="scope">
           <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="scope.row.options.proto" size="small">
            <el-option
              v-for="item in protocolList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.Externalzone')}`">
        <template slot-scope="scope">
          <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="scope.row.options.src" size="small">
            <el-option
              v-for="item in wanList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.port.outerPort')}`">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.options.src_dport"></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.Internalzone')}`">
        <template slot-scope="scope">
          <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="scope.row.options.dest" size="small">
            <el-option
              v-for="item in lanList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.InternalIPaddress')}`" min-width="130px">
        <template slot-scope="scope">
          <el-input ref="dest" v-if="destInputShow" size="mini" v-model="scope.row.options.dest_ip" @blur="destBlur"></el-input>
          <el-select v-else size="mini" class="Form-Input-Width" v-model="scope.row.options.dest_ip" @change="(val)=>destChange(val,scope.$index)">
            <el-option v-for="(item, index) in IpList" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.port.innerPort')}`">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.options.dest_port"></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.port.enable')}`">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.options.enabled"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.operating')}`" min-width="150px">
        <template slot-scope="scope">
          <el-button @click="addRedirect(scope.row)" type="primary" size="small">{{$t('lang.Button.Add')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import SelectInput from '../../SelectInput/index'
import { listConfig } from '@/api/configurationlist'

export default {
  props:["deviceDid", "deviceSn", 'IpList'],
  components: {
    SelectInput,
  },
  data() {
    return {
      redirect: [
        {
          index: '',
          options: {
            dest_port: '',
            enabled: false,
            dest_ip: '',
            dest: 'lan',
            src_dport: '',
            src: 'wan',
            proto: 'tcp udp',
            name: ''
          },
          action: 1,
          sname: ''
        }
      ],
      protocolList:[
        {value:'tcp udp',label:'TCP+UDP'},
        {value:'tcp',label:'TCP'},
        {value:'udp',label:'UDP'},
        {value:'other',label: this.$t('lang.port.other')}
      ],
      wanList:[
        {value:'wan',label:'wan'}
      ],
      lanList:[
        {value:'lan',label:'lan'}
      ],
      destInputShow: false
    }
  },
  methods: {
    clearData(){
       this.redirect = [
        {
          index: '',
          options: {
            dest_port: '',
            enabled: false,
            dest_ip: '',
            dest: 'lan',
            src_dport: '',
            src: 'wan',
            proto: 'tcp udp',
            name: ''
          },
          action: 1,
          sname: '',
        }
      ]
    },   
    //修改内部Ip地址
    Dest_ipSelectInput(props,index){
      this.redirect[0].options.dest_ip=props
    },
    addRedirect(row) {
      let data = this.redirect[0].options
      if(data.dest_port == '' || data.src_dport == '' || data.name == '') {
        this.$confirm(this.$t('lang.port.addTips'), this.$t('lang.port.tips'), {
          confirmButtonText: this.$t('lang.Button.submit'),
          cancelButtonText: this.$t('lang.Button.cancel'),
        }).then(() => {
          this.$emit('addRedirect', this.redirect[0])
          this.clearData()
        }).catch(() => {
        })
      }else{
        this.$emit('addRedirect', this.redirect[0])
        this.clearData()
      }
    },
    // 监听选择下拉框的变化
    destChange(val, index) {
      if(val === '自定义') {
        this.redirect[index].options.dest_ip = ''
        this.destInputShow = true
        this.$nextTick(() =>{
          this.$refs.dest.focus()
        })
      }
    },
    destBlur(){
      this.destInputShow = false
    }
  }
}
</script>